import { SnackbarAtom } from '@store';
import { useAtom } from 'jotai';
import { useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';

export const ToastBar = () => {
	const isIframe = window.self !== window.top;
	const [toastBar] = useAtom(SnackbarAtom);
	const scrollYRef = useRef(0);

	// Scroll-Position vom Parent empfangen
	useEffect(() => {
		if (!isIframe) return;

		const handleMessage = (e: MessageEvent) => {
			if (e.data?.type === 'scroll') {
				scrollYRef.current = e.data.scrollY;
			}
		};

		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, [isIframe]);

	const showHelloToast = async () => {
		const { text } = toastBar || {};
		const texts = text.split(' | ');

		// Viewport-Höhe des iframes
		const viewportHeight = window.innerHeight;
		// Wo im iframe ist der sichtbare Bereich?
		const visibleTop = scrollYRef.current;

		// Toast oben oder unten im sichtbaren Bereich anzeigen
		const position = visibleTop > viewportHeight / 2 ? 'top-left' : 'bottom-left';

		if (texts.length > 0) {
			texts?.forEach((splitText) => {
				switch (toastBar.color) {
					case 'success':
						toast.success(splitText, { position });
						break;
					case 'error':
						toast.error(splitText, { position });
						break;
					case 'info':
						toast.info(splitText, { position });
						break;
					default:
						toast(splitText, { position });
				}
			});
		}
	};

	useEffect(() => {
		if (toastBar?.text) {
			showHelloToast();
		}
	}, [toastBar]);

	return (
		<ToastContainer
			position={isIframe ? 'top-left' : 'bottom-left'}
			className={'mx-5'}
			style={{ width: '90%' }}
			toastStyle={{ marginTop: '10px' }}
		/>
	);
};
